export default __webpack_public_path__ + "static/media/plus.55546b78.svg";